// extracted by mini-css-extract-plugin
module.exports = {"tab":"PatientInfoPanel_tab__2Ab6x"};